import React from 'react';
import InnerFilterContent, { FilterInnerContentProps } from '../../common/DropdownContent/DynamicFilterInnerContent';
import { OrderUtil } from '../../../../../types/order/';

export default function OrderStatusFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<string>) {
  return (
    <InnerFilterContent
      filter={filter}
      filterProps={{ filterProps, setFilterProps }}
      items={[...(filterProps.orderStatus || [])]}
      text={item => OrderUtil.statusToString(item)}
      onRemove={i => {
        filterProps.orderStatus?.delete(i);
        if (!filterProps.orderStatus?.size) filterProps.orderStatus = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
